import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=910dfcb4"
import script from "./MainDialog.vue?vue&type=script&lang=js"
export * from "./MainDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('910dfcb4')) {
      api.createRecord('910dfcb4', component.options)
    } else {
      api.reload('910dfcb4', component.options)
    }
    module.hot.accept("./MainDialog.vue?vue&type=template&id=910dfcb4", function () {
      api.rerender('910dfcb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/MainDialog.vue"
export default component.exports